import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 986,
	height: 42,
	viewBox: "0 0 986 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M720.192 2.13889C802.508 -0.943574 854.802 -3.50604 930.091 15.6303C961.812 23.693 1006 42 1006 42H0C0 42 249.517 25.6858 301.476 21.7628C383.44 15.5744 430.036 35.6511 512.455 31.8814C595.853 28.0669 636.706 5.2652 720.192 2.13889Z",
		fill: "#C3D0E6",
		fillOpacity: .3
	})
});
const SvgSnowFrontDark = styled(base)({});
export default SvgSnowFrontDark;
